module.exports = __webpack_public_path__ + "img/recognition-icon.283e5f8f.svg";